export default {
    menu_dashboard: 'ផ្ទាំងគ្រប់គ្រង',
    menu_domain: 'ដែន',
    menu_cloud_hosting: 'ប្រព័ន្ធផ្ទុកពពក',
    menu_shared_hosting: 'ចែករំលែកប្រព័ន្ធផ្ទុក',
    menu_wp_hosting: 'ការបង្ហោះ WordPress',
    menu_cloud_server: 'Cloud Server',
    menu_invoice: 'វិក្ក័យប័ត្រ',
    menu_profile: 'ប្រវត្តិរូប',
    menu_wallet: 'ការទូទាត់',
    menu_sms: 'សេវាសារ SMS',
    menu_aws: 'AWS',
    menu_api: 'ការគ្រប់គ្រងគន្លឹះ API',
    menu_promo_credit: 'ឥណទានផ្សព្វផ្សាយ',
    menu_affiliate: 'ចូលជាសមាជិក',
    menu_loyalty_program: 'ភក្តីភាព',
    menu_ssl: 'វិញ្ញាបនបត្រ SSL',
};
